import type { TView as TViewTextV2 } from '@alfa-bank/site-text-v2/src/models';

import type { IConfig, TTitleView } from './models';

export const getTextView = (config: IConfig, titleView: TTitleView = 'default'): TViewTextV2 =>
    config[titleView];
